import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VideoPlayerData } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class FullScreenPlayService {
  public isActivePlay = new BehaviorSubject<VideoPlayerData>(null);

  startFullScreenPlay(data: VideoPlayerData): void {
    this.isActivePlay.next(data);
  }

  stopFullScreenPlay(): void {
    this.isActivePlay.next(null);
  }
}
